import { render, staticRenderFns } from "./crm_contacts.vue?vue&type=template&id=1bdf1ae2"
import script from "./crm_contacts.vue?vue&type=script&lang=js"
export * from "./crm_contacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports